// import Vue from "vue";
import App from "./App.vue";
// 使用优化后的路由配置，实现home路由优先加载
import router from "./router.js";
import store from "./store/index";
// import echarts from "echarts";
// import Avue from '@smallwei/avue';
// import elementui from "element-ui";
import '@/components/newComponents/registerGlobComp'
// import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/mixis.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import "./assets/style/element-ui.scss";
import './assets/homeDemo/fonts/fonts.css';
// import moment from "moment";
// import Vuex from "vuex";
import "./resgisterServiceWorker";
// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/css/swiper.min.css";
import constant from "./utils/constants.js";
import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/reset.css";
import "./assets/font/iconfont.css";
import "./assets/rem";
import VueViewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// import gojs from 'gojs'
// import clipboard from "clipboard";
import { loginController } from "@/api/activityController";
import { uploadPointData } from "@/api/home.js"
import { checkPermisson } from "@/common/permission"
import {
  getSellerInfo, getSeller
} from "@/api/sellerController";
// import VueVideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
import common from './common/decrypt'
import commonJS from "./utils/common.js";
// import 'babel-polyfill'
import commonOptimization from './common/commonOptimization'

// import Es6Promise from 'es6-promise'
// import JSEncrypt from '@/utils/jsencrypt.min'
import Festivals from "./components/Message/festivals.vue"
// import JDButton from "@/components/new/jd-button.vue";
import JDTitle from "@/components/new/jd-title.vue";
// import JDTipBox from "@/components/new/tip-box.vue";
import JDTabPermission from "@/components/new/jd-tabs-permission.vue";
import myTab from "@/components/myTab.vue";
import subTab from "@/components/subTab.vue";
import decryptBatchObj from './common/batchDecrypt'
import inputForm from "@/components/jhk/inputForm";
import generate from "@/components/generate_report.vue";

// 指引组件
import QuestionMarkPrompt from "@/components/promptCom/questionMarkPrompt.vue";
Vue.component("questionMarkPrompt", QuestionMarkPrompt);

// 懒加载
// import VueLazyload from "vue-lazyload";

require('es6-promise').polyfill()

ES6Promise.polyfill()

Vue.prototype.clipboard = ClipboardJS;
//图片拖动排序
import VueDND from "awe-dnd";

Vue.use(VueDND);
Vue.use(VueViewer);
Vue.use(VueVideoPlayer);
Vue.use(commonJS);
// Vue.component("jd-button", JDButton);
// Vue.component("jd-tip", JDTipBox);
// Vue.component("jd-title", JDTitle);
Vue.component("festivals", Festivals);
Vue.component("jd-myTab", myTab);
Vue.component("jd-subTab", subTab);
Vue.component("jd-tabs-permission", JDTabPermission);
Vue.component("input-form", inputForm);
Vue.component("generate", generate);
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

/***************引入gojs为原型函数*************************************/
Vue.prototype.$go = go
Vue.prototype.$make = go.GraphObject.make
// 双击解密
Vue.prototype.$decrypt = common;
Vue.prototype.$globalData = {
  scaleValue:1,
  widthValue:0,
};

//el-input挂载
import onlyNumber from "@/directive/el-input"; //添加此行=>自定义全局指令
import tooltip from "@/directive/tooltip"; //添加此行=>自定义全局指令

Vue.use(onlyNumber); //添加此行=>使用该全局指令
Vue.use(tooltip); //添加此行=>使用该全局指令

Vue.use(Vuex);

Vue.use(moment);
// Vue.use(Avue);
Vue.use(ELEMENT, { size: "small", zIndex: 3000 });
Vue.use(echarts);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(constant);
Vue.use(utils);

// 懒加载
Vue.use(VueLazyload, {
  // ""懒加载默认图片路径
  // loading: require(""),
});

// Vue.prototype.jq = jquery
// 双击解密
Vue.prototype.$decrypt = common;

// 批量解密
Vue.prototype.$decryptBatch = decryptBatchObj;

Vue.prototype.moment = moment;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

Vue.prototype.$globalCdn = 'https://cdn-image.yucrm.cn/images/dyAssets'; // CDN地址前缀

Vue.config.productionTip = false;

Vue.prototype.bus = new Vue();

Vue.prototype.$jingdouTotal = commonOptimization.jingdouTotal
Vue.prototype.$getDate = commonOptimization.getDate
Vue.prototype.$getActDate = commonOptimization.getActDate
Vue.prototype.$commonUrl = commonOptimization.commonUrl
Vue.prototype.$toChinesNum = commonOptimization.toChinesNum

// 配置当前玩法的默认分享海报
// id：玩法id  返回值为图片地址
Vue.prototype.getDefaultSharePic = function(id){
  switch (id) {
    case 1: // 签到
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_641dcd9356ce43768b45e127fba176b3.png"
    case 3: // 每日限时抢
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c877055d2d5e450a90be5101f38d30a4.png"
    case 4: // 关注店铺有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_4d33db69ca024903843d99a9a79e2a53.png"
    case 5: // 邀请开卡有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d179bed0c9f94747a1935b0323856796.png"
    case 6: // 邀请关注有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_f1b051fe8b6c43d787bec7510bf70762.png"
    case 7: // 完善信息有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_878e1739c2214440b312ea8a235446a4.png"
    case 8: // 幸运抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c1f527acd10947528b7ee35398fdb062.png"
    case 16: // 下单有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_e2457cd5a00e4059b8e4c38f9c59cfce.png"
    case 17: // 首购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_60af7364b2c94ae79cb0aaee9e4dc20f.png"
    case 18: // 复购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_18256c6db9ad49eeaff4875b46cd5738.png"
    case 19: // 下单抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d70f9a4540eb4ed6b6d6c0c500f3b970.png"
    case 20: // 评价有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5596ffd7934a4357bee8a162a97b57d3.png"
    case 21: // 裂变神券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5cf953d0208e4a9eb8e7217ddabc8cc6.png"
    case 22: // 天降红包雨
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_baed0f4b975b42e2bafceb8b85df4fef.png"
    case 23: // 欢乐娃娃机
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_794a6b6194d34dbea0f4b7c77d197f2c.png"
    case 24: // 大家来找茬
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_b9ecef75382a4dcdb217eba4daf8429f.png"
    case 27: // 预售有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_7340c47bbeda451ea8eb39de2644510e.png"
    case 28: // 预售抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_9e504eae36d148a294359f00875fd540.png"
    case 31: // 超级裂变券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_57a1234181024b3b850f6596b32c67e3.png"
    case 34: // 加购有礼
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5108d958fef14a688d435033dbf29a90.png'
    case 35: // 积分锁权
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_lockAuthShare.jpg'
    case 36: // 打榜有礼
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/share_xdcb.png'
    case 37: // 派样回购礼
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E5%88%86%E4%BA%AB%E5%9B%BE.jpg'
    case 46: // 满额有礼
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/maneyouli.png'
    case 41: // 华为-晒单有礼
      return 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/share_sdyl.png'
    case 45: // 积分锁权
      return 'https://cdn-image.yucrm.cn/hd/images/jfsq.png'
    case 47: // 调查问卷
      return 'https://cdn-image.yucrm.cn/hd/images/dcwj.png'
    case 48: // 定时开奖
      return 'https://cdn-image.yucrm.cn/hd/images/dskj.png'
    case 51: // 0元试用
      return 'https://cdn-image.yucrm.cn/hd/images/0ysy.png'
    case 52: // 试用回购礼
      return 'https://cdn-image.yucrm.cn/hd/images/syhgl.png'
    case 53: // 购物打卡
      return 'https://cdn-image.yucrm.cn/hd/images/gwdk.png'
    case 54: // 幸运抽奖(定制)
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c1f527acd10947528b7ee35398fdb062.png"
    case 62: // 集卡有礼
      return 'https://cdn-image.yucrm.cn/hd/images/collectcard-share.png'
    case 64: // 组队瓜分奖品
      return 'https://cdn-image.yucrm.cn/4554f36b2bf4422abedeba905722ed38.png'
    case 65: // 粉丝打卡
      return 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/fans.png'
    case 66: // 入会有礼
      return 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/giftShare.png'
    case 63: // BI店铺礼包
      return 'https://cdn-image.yucrm.cn/hd/images/collectcard-share.png'
    case 67: // 销售打榜
      return 'https://cdn-image.yucrm.cn/a61f1bf04296483b91bd2c96eb3ef206.png'
    case 68: // 用户生命周期
      return 'https://cdn-image.yucrm.cn/hd/images/%E7%94%9F%E5%91%BD%E5%91%A8%E6%9C%9F.png'
    case 69: // 拼团砍价
      return 'https://cdn-image.yucrm.cn/hd/images/ptkj.png'
    case 70: // 拼团砍价
      return 'https://cdn-image.yucrm.cn/hd/images/point.png'
    case 77: // 购物车锦鲤
      return 'https://cdn-image.yucrm.cn/hd/images/shareGw.png'
    default:
      break;
  }
}


Vue.filter('numberThree', (val) => {
  return Number(val).toLocaleString()
})

const VUE = this

Vue.directive('permission', {
  inserted(el, binding) {
    let permission = []
    let permissionsInterval = setInterval(() => {
      if (store.getters.loginUserInfo && store.getters.loginUserInfo.permissions) {
        permission = store.getters.loginUserInfo.permissions;
        if (permission.length) {
          if (permission.includes("*:*:*")) {
            // 有全部权限
            el.style.display = 'inline-block'
          } else {
            if (permission.includes(binding.value)) {
              el.style.display = 'inline-block'
            } else {
              el.style.display = 'none'
            }
          }
        } else {
          el.style.display = 'none'
        }
        clearInterval(permissionsInterval);
      }
    }, 150);
  }
})

Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})
// 输入框只能输入正整数
Vue.directive('numZOnly', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/^(0+)|[^\d]+/g, "");
    });
  },
});

// 输入框只能输入数字
Vue.directive('numeric-only', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      const filteredValue = inputValue.replace(/[^\d.]/g, '');
      event.target.value = filteredValue;
    });
  },
});

let maidian = (value) => {
  if (window._hmt && !!value) {
    window._hmt.push(['_trackEvent', '按钮点击', 'click', `${value.from}-${value.name}`]);
  }
}
// 按钮埋点
Vue.directive('zoom', {
  inserted(el, binding) {
    el.onclick = () => maidian(binding.value)
  },

  update(el, binding) {
    let old = binding.oldValue.from
    let newV = binding.value.from
    if (old != newV) {
      // console.log(el);
      // el.removeEventListener('click', ()=>maidian(binding.oldValue),false)
      el.onclick = false
      el.onclick = () => maidian(binding.value)
    }

  }
})
// 标签埋点
Vue.directive('labelZoom', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', '标签选择', 'active', `${binding.value.name}`]);
      }
    })
  }
})

Vue.directive('natural-number', {
  bind: function (el) {
    el.handler = function (e) {
      const input = e.target;
      input.value = input.value.replace(/[^0-9]/g, ''); // 只保留数字
    };
    el.addEventListener('input', el.handler);
  },
  unbind: function (el) {
    el.removeEventListener('input', el.handler);
  }
});


// 定时器标识
let timer = null
let timeEnter = null
let times = 0

// 埋点计时器
Vue.prototype.setIntervalFun = async function (name, firstClassify, secondClassify, id) {
  if (!id) return
  timer = setTimeout(() => {
    times = times + 1
    // 页面停留超过1小时，停止埋点
    if (times >= 150) {
      // console.log(times);
      this.clearBuriedPoint()
      // console.log('停止埋点');
      return
    }
    this.buriedPointTimes(name, firstClassify, secondClassify, id)
    // console.log('埋点成功', name, firstClassify, secondClassify);
  }, 4000)
}
// 清除埋点
Vue.prototype.clearBuriedPoint = function () {
  clearTimeout(timer)
}
let route
// 页面埋点
Vue.prototype.buriedPoint = async function (action, name, firstClassify, secondClassify,type,uploadPointDataCallBack) {
  let flage = false
  if (!flage) {
    this.clearBuriedPoint()
    clearTimeout(timeEnter)
    flage = true
  }
  if (flage) {
    setTimeout(async () => {
      times = 0
      var route = this.$route.path
      let params = {
        platform: 'jdp',
        venderId: '',
        shopTitle: '',
        source: 0,//来源 0:pc端 1:移动端
        action: action,//类型 1进入页面 2点击按钮 3授权进入 4操作
        url: route,// 路径
        name: name,//"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(),//JSE加密
        firstClassify: firstClassify, // 一级分类
        secondClassify: secondClassify, // 二级分类
        type:type
      }
      // 当前店铺信息
      let { data: userInfo } = await getSeller()
      // 指定商家列表  列表中的商家将拥有500个人群策略名额
      var shopList = [
        1000371063,
        1000003788,
        1000077584,
        1000002591,
        1000002983,
        1000001782,
        1000104815,
        1000002743,
        691846,
        1000282702,
        1000007398,
        51168,
        1000003111,
        87658
      ]
      if(shopList.indexOf(userInfo.venderId) != -1){
        this.$store.state.peopleNumState = true
      }else{
        this.$store.state.peopleNumState = false
      }
      // console.log(userInfo);
      // 当前店铺信息
      params.venderId = this.$store.state.loginUserInfo.platformFlag ?
        (this.$store.state.loginUserInfo.platformAccountInfo ? this.$store.state.loginUserInfo.platformAccountInfo.platformCompanyUserId : '')
        : this.$store.state.loginUserInfo.venderId
      params.shopTitle = this.$store.state.loginUserInfo.shopTitle
      // 调用埋点
      // console.log(this.$store.state);
      try {
        let res = await uploadPointData(params)
        if (res.code) {
          // this.clearBuriedPoint()
          this.buriedPointTimes(name, firstClassify, secondClassify, res.data)
          uploadPointDataCallBack && uploadPointDataCallBack()
        }
      } catch (error) {
        console.log(error);
        uploadPointDataCallBack && uploadPointDataCallBack()
      }
    }, 500)
  }
}

// 轮询埋点
Vue.prototype.buriedPointTimes = async function (name, firstClassify, secondClassify, id) {
  var route = this.$route.path
  let params = {
    platform: 'jdp',
    venderId: '',
    shopTitle: '',
    source: 0,//来源 0:pc端 1:移动端
    action: 5,//类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route,// 路径
    name: name,//"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(),//JSE加密
    firstClassify: firstClassify, // 一级分类
    secondClassify: secondClassify, // 二级分类
    requestId: id // 请求id
  }
  params.venderId = this.$store.state.loginUserInfo.platformAccountInfo ? this.$store.state.loginUserInfo.platformAccountInfo.platformCompanyUserId : this.$store.state.loginUserInfo.venderId
  if (this.$store.state.loginUserInfo.yunZhouOtherType == 1) { // 京获客旗舰版
    params.venderId = this.$store.state.loginUserInfo.venderId
  }
  params.shopTitle = this.$store.state.loginUserInfo.shopTitle
  // 调用埋点
  let res = await uploadPointData(params)
  // 轮询-埋点
  this.clearBuriedPoint()
  this.setIntervalFun(name, firstClassify, secondClassify, id)
}

// JSEncrypt加密
const encryptMI = function (origin = Date.now()) {
  // 公钥
  const key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB'
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(key)
  return encrypt.encrypt(origin + '')
}

//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
  var hm = document.createElement("script");
  hm.src = hm.src = "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
router.beforeEach((to, from, next) => {
  // const resp = await getSellerInfo()
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', "/" + to.fullPath])
    }
  }
  // 忠诚度积分登录
  if (to.fullPath.indexOf('integralCenter') != -1 && !store.state.pointUserInfo) {
    getSellerInfo().then((resp) => {
      // 店铺ID
      let venderId = { venderId: resp.data.venderId }
      // 积分登录
      loginController(venderId)
        .then((res) => {
          sessionStorage.setItem("loginValue", res.code);
          if (res && res.code == 1) {
            if (
              res.data.appInfo.status == 1 &&
              res.data.orderInfo.status == 1
            ) {
              store.commit('POINTUSERINFO', res.data.orderInfo)

              // this.editPointUserInfo(res.data.orderInfo)
            } else if (res.data.orderInfo.status != 1 && resp.data.subscribeType == 2) {
              let routeUrl = router.resolve({
                path: "/prizeCenter2",
              });
              window.open(routeUrl.href, "_self");
              // window.open("/home", "_self");
            } else if (res.data.orderInfo.status == 1) {
              window.open(res.data.appInfo.authUrl, "_blank");
              window.open("/home", "_self");
            }
          } else {
            if (res.data.data.orderInfo.status != 1 && resp.data.subscribeType == 2) {
              let routeUrl = router.resolve({
                path: "/prizeCenter2",
              });
              window.open(routeUrl.href, "_self");
              // window.open("/home", "_self");
            } else if (res.data.data.orderInfo.status == 1) {
              window.open(res.data.data.appInfo.authUrl, "_blank");
              window.open("/home", "_self");
            }

          }
          next();
        })
        .catch((res) => {
          this.$message.error("积分登录失败");
          window.open("/home", "_self");
        });
    })

  } else {
    if (process.env.NODE_ENV == "production" && to.path == "/login" && to.path == "/platformLogin") {
      next("/home");
    }
    const query = Object.fromEntries(new URLSearchParams(window.location.search))
    if(query.isIframe){
      next();
      return;
    }
    const routeObj = checkPermisson(to)
    if (!routeObj.next) {
      next();
    } else if (routeObj.path !== "" && routeObj.next) {
      next(routeObj.path);
    }
    // else if(routeObj.path === "" && routeObj.next){
    //   next("/nopermission");
    // }

  }
});

if (window.location.href.indexOf("localhost") > -1) {
  console.log("本地放开打印");
}else {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.dir = function () {};
}

// console.log = function(){};
// console.error = function(){};
// console.dir = function(){};
// console.warn = function(){};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");